export default __webpack_public_path__ + "static/media/discord.32763b7f.webp";